module.exports = __webpack_public_path__ + "static/media/group.f5f2791b.svg";